<template>
  <div id="mergeTagList">
    <v-toolbar color="grey lighten-3" height="40">
      <v-toolbar-title :class="titlePadding">Merge Tags</v-toolbar-title>
    </v-toolbar>
    <v-text-field
        @keydown.native.escape="mergeTagSearch=''"
        v-model="mergeTagSearch"
        label="Search"
        hint="Filter Merge Tags"
        persistent-hint
        clearable
        single-line
        :class="searchPadding"
      >
      </v-text-field>
      <v-list :class="listPadding" shaped dense>
        <v-list-item v-for="(mergeTag, i) in filteredMergeTags" :key="i" @click="copy(mergeTag.value)">
          <v-list-item-content><v-list-item-title>{{ mergeTag.name }}</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CopyTextMixin } from '@/components/mixins'
import SidebarPropsMixin from './SidebarPropsMixin'

export default {
  name: 'merge-tag-sidebar',
  mixins: [CopyTextMixin, SidebarPropsMixin],
  components: {},
  data: function () {
    return {
      mergeTagSearch: ''
    }
  },
  computed: {
    ...mapState('EmailTemplateStore', ['mergeTags']),
    filteredMergeTags () {
      if (!this.mergeTagSearch) {
        return this.mergeTags
      }
      let result = this.mergeTags.filter(row => {
        let isIncluded = false
        if (row.name.toLowerCase().includes(this.mergeTagSearch.toLowerCase())) {
          isIncluded = true
        } else if (row.value.toLowerCase().includes(this.mergeTagSearch.toLowerCase())) {
          isIncluded = true
        }
        return isIncluded
      })
      return result
    }
  }
}
</script>
